export { ProductsService } from './products.service';
